import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { CheckAuthResponse } from '../core/models';
import { switchMap } from 'rxjs';
import { ProfileService } from '../core/profile.service';

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
})
export class LoginComponent {
  private fb: FormBuilder = inject(FormBuilder);
  private auth: AuthService = inject(AuthService);
  private profile: ProfileService = inject(ProfileService);

  today = new Date();

  loginForm = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  });

  loginError = signal<boolean>(false);
  loginErrorMsg: string = '';

  screenheight: number = 0;
  screenwidth: number = 0;
  mobile: boolean = false;

  @HostListener('window:resize')
  getScreenSize() {
    if (window.innerWidth == this.screenwidth) {
      return;
    }

    this.screenheight = window.innerHeight;
    this.screenwidth = window.innerWidth;

    if (this.screenwidth <= 450) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  ngOnInit(): void {
    this.getScreenSize();

    this.auth.isLoggedIn().subscribe((resp: CheckAuthResponse) => {
      if (resp.isLoggedIn) {
        this.router.navigate(['/']);
      }
    });
  }

  constructor(private router: Router) {}

  authenticate() {
    if (!this.loginForm.valid) {
      return false;
    }

    const { username, password } = this.loginForm.value;
    this.auth
      .authenticate(username as string, password as string)
      .pipe(switchMap(() => this.profile.loadProfile()))
      .subscribe({
        next: () => {
          this.loginError.set(false);
          this.router.navigate(['/']);
        },
        error: (err) => {
          this.loginError.set(true);
          this.loginErrorMsg = err.error;
        },
      });
    return false;
  }
}
